module.exports = __webpack_public_path__ + "img/Laurent.2fea0ff7.png";